<template>
    <div class="head-tabs">
        <b-nav tabs>
            <b-nav-item 
              :to="{ path: '/wallet/list'}" 
              v-if="permission.hasAccess('s-wallet.wallet')"
            >
                Wallet
            </b-nav-item>
            <b-nav-item 
              :to="{ path: '/wallet/archive'}"
              v-if="permission.hasAccess('wallet.archive')"
            >
                Archive
            </b-nav-item>
            <b-nav-item 
              :to="{ path: '/wallet/history'}" 
              v-if="permission.hasAccess('s-wallet.wallet-history')"
            >
                Wallet History
            </b-nav-item>
            <b-nav-item 
              :to="{ name: 'wallet-capping'}"
              v-if="permission.hasAccess('s-wallet.wallet-capping')"
            >
                Wallet Capping
            </b-nav-item>
        </b-nav>
    </div>
</template>

<script>
import permission from "@/services/user.permission";

export default {
  name: "wallet-nav",
  data() {
    return {
      msg: "Wallet Nav",
      permission: permission,
    };
  },
};
</script>